'use client';

import React from 'react';
import PropTypes from 'prop-types';
import MapMarker from '../Shared/MapMarker';

ClinicList.propTypes = {
    results: PropTypes.array.isRequired,
    curTab: PropTypes.string,
};

export default function ClinicList({ results, curTab }) {

    return (
        <div className={` ${curTab == 'list' ? '' : 'u-hidden'}`}>
            {results.length > 0 ? (
                <div className="searchListWrapper__inner">
                    {results.map((clinic) => {

                        const mapIcon = (
                            <MapMarker type={clinic.flagship ? 'flagship' : 'pharmacy'} />
                        );

                        return (<div
                            key={clinic.id}
                            className={`clinic-finder__list-item`}
                        >
                            <h3
                                className="searchListWrapper__title"
                            >{mapIcon} <span dangerouslySetInnerHTML={{
                                __html: clinic.title,
                            }}></span></h3>
                            <address
                                className="searchListWrapper__address"
                                dangerouslySetInnerHTML={{
                                    __html: clinic.address.replace(
                                        /[<]br[^>]*[>]/gi,
                                        ''
                                    ),
                                }}
                            ></address>

                            {clinic.distance && (
                                <p className="searchListWrapper__distance">
                                    {clinic.distance} miles <small>(approx)</small>
                                </p>
                            )}

                            <div className="clinic-finder__list-ctas">

                                <a
                                    className="clinic-finder__clinic-link"
                                    href={clinic.url}
                                >
                                    Clinic Details
                                </a>


                            </div>


                        </div>)
                    })}
                </div>
            ) : (
                <p className="searchListWrapper__error">No clinics found</p>
            )}
        </div>
    );
}
